var _style, _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000030446750108789484120000002605699345184819850_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 13.5,
    y: 16.7,
    width: 30,
    height: 30
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000061444602836902460390000008765322950859788431_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000061444602836902460390000008765322950859788431_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5,16.7c-4,0-7.8,1.6-10.6,4.4c-2.8,2.8-4.4,6.6-4.4,10.6c0,4,1.6,7.8,4.4,10.6c2.8,2.8,6.6,4.4,10.6,4.4 c2.6,0,5.2-0.7,7.5-2c2.3-1.3,4.2-3.2,5.5-5.5c1.3-2.3,2-4.9,2-7.5c0-4-1.6-7.8-4.4-10.6C36.3,18.3,32.5,16.7,28.5,16.7L28.5,16.7 z M36,31.7c0,0.3-0.1,0.6-0.4,0.9l-4.9,4.9c-0.3,0.3-0.7,0.4-1.2,0.3c-0.4-0.1-0.7-0.4-0.9-0.9c-0.1-0.4,0-0.9,0.3-1.2l2.9-2.9 h-9.7c-0.4,0-0.8-0.2-1-0.6c-0.2-0.4-0.2-0.8,0-1.2c0.2-0.4,0.6-0.6,1-0.6H32L29,27.6h0c-0.3-0.3-0.4-0.8-0.3-1.2 c0.1-0.4,0.4-0.7,0.9-0.9c0.4-0.1,0.9,0,1.2,0.3l4.9,4.9C35.9,31,36.1,31.3,36,31.7L36,31.7z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/active.322a58c1e06d7fc165d9e59ad492bb13.svg";
export { ForwardRef as ReactComponent };